import { useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminSectionTitle from '../components/AdminSectionTitle';
import useGetSelectedEvent from '../hooks/useGetSelectedEvent';
import EventCashRegisterTable from '../components/EventCashRegisterTable';
import HorizontalTabs from '../components/atoms/HorizontalTabs';
import SessionsTable from '../components/SessionsTable';
import { useGetBusinessCashRegistersQuery, useGetEventCashRegistersQuery } from '../store';
import EventDTO, { EventCashRegisterDTO } from '../models/event';
import { BusinessCashRegisterDTO } from '../models/business';
import LoadingLottie from '../components/atoms/LoadingLottie';

const InPersonPage = () => {
  const { event_id: eventIdFromParams, business_id: businessIdFromParams } = useParams<{ event_id: string; business_id: string }>();
  const { event } = useGetSelectedEvent();
  const [selectedTab, setSelectedTab] = useState<'registers' | 'sessions'>('registers');
  const { data: businessCashRegisters, isLoading: isLoadingBusinessCashRegisters } = useGetBusinessCashRegistersQuery({
    businessId: businessIdFromParams || '',
  }, { skip: !businessIdFromParams });

  const eventId = event?.id || eventIdFromParams;
  const businessId = (event as EventDTO & { business_id?: string })?.business_id || businessIdFromParams;

  const { data: eventCashRegisters, isLoading: isLoadingEventCashRegisters } = useGetEventCashRegistersQuery({
    businessId: businessId || '',
    eventId: eventId || '',
  }, { skip: !businessId || !eventId });

  if (isLoadingBusinessCashRegisters || isLoadingEventCashRegisters) {
    return <LoadingLottie />;
  }

  return (
    <div className="flex flex-col gap-8 my-6">
      <AdminSectionTitle title="Eventos" subtitle={`${event?.name} - Venta presencial`} />
      <div className="glass-surface flex flex-col gap-4">
        <HorizontalTabs
          tabs={[
            { label: 'Cajas', onClick: () => setSelectedTab('registers'), selected: selectedTab === 'registers' },
            { label: 'Sesiones', onClick: () => setSelectedTab('sessions'), selected: selectedTab === 'sessions' },
          ]}
        />
        {selectedTab === 'registers' && (
          <EventCashRegisterTable
            event={event as EventDTO}
            eventCashRegisters={eventCashRegisters as EventCashRegisterDTO[] | undefined}
            isLoadingEventCashRegisters={isLoadingEventCashRegisters}
          />
        )}
        {selectedTab === 'sessions' && (
          <SessionsTable
            businessCashRegisters={businessCashRegisters as BusinessCashRegisterDTO[] | undefined}
            eventCashRegisters={eventCashRegisters as EventCashRegisterDTO[] | undefined}
            isLoadingEventCashRegisters={isLoadingEventCashRegisters}
          />
        )}
      </div>
      <div className="glass-surface">
        <h2 className="text-xl font-semibold mb-4 text-text-primary">Instructivo para la venta presencial</h2>
        <ol className="list-decimal pl-5 space-y-2 text-text-primary">
          <li>Abrí caja: Encontrá en esta página el listado de cajas activas. Ubicá la caja donde te encontrás y en "Acción" seleccioná "Abrir caja"</li>
          <li>Declará el monto en efectivo con el que contas al abrir la caja.</li>
          <li>¡Ya podés comenzar a vender! Seleccioná la cantidad de entradas que el cliente solicita y el medio de pago que va a usar al abonarlas. Al tocar el botón "Vender entradas" confirmas la orden y un ticket se imprimirá como comprobante para el cliente.</li>
          <li>Cerrá caja: Una vez que tu turno termina, seleccioná "Cerrar caja" en la parte superior de la pantalla. Para confirmar el cierre deberás declarar el monto en efectivo con el que contas al cerrar la caja.</li>
          <li>¡Listo! una vez cerrada, la caja puede volver a abrirse dentro del horario establecido para el evento.</li>
          <p className="mt-2 text-text-primary">Ante cualquier duda consultá con el productor del evento o con el soporte de Avantti.</p>
        </ol>
      </div>
    </div>
  );
};

export default InPersonPage;
